import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DlistDto } from '../../../models/ortak.dtos';
import { DataCoreService } from '../../../services/data-core.service';
import { HttpClient } from '@angular/common/http';
import { FilterDescriptor } from 'devextreme/data';
import { environment } from '../../../services/app-settings.service';

@Injectable({
  providedIn: 'root',
})
export class CtlRowEditSearchPopupService {
  public _gridControlsList: BehaviorSubject<DlistDto | null> =
    new BehaviorSubject(null);
  public gridControlsList$ = this._gridControlsList.asObservable();

  constructor(
    private dataCoreService: DataCoreService,
    private _httpClient: HttpClient
  ) {}

  getData(
    control: any,
    filterArrP: FilterDescriptor | Array<FilterDescriptor>[] = [],
    key: string,
    kod?: any
  ) {
    const columnArray: string[] = control.searchColumns?.split(',');
    const dataSource = this.dataCoreService.getOData(
      control.dlistMetadata.baseEntity,
      null,
      null,
      key
    );
    dataSource.select(columnArray);
    const filterArr = [];
    if (filterArrP.length > 0) {
      filterArr.push(filterArrP);
    }
    if(kod) {
      filterArr.push([key, '=', kod]);
    }

    if (filterArr.length > 0) dataSource.filter(filterArr);
    return dataSource;
  }

}
